import React, { useState, useRef, useEffect } from "react";
import { TOKENS } from "Static/constant";
import { settingsStoreData } from "Stores/settingsData";
import TokenVariable from "Components/common/TokenVariable";

// T object removed, styles moved to _conditionBuilderPopup.scss

const OPERATORS = [
  { value: "equals", label: "equals" },
  { value: "not_equals", label: "does not equal" },
  { value: "contains", label: "contains" },
  { value: "is_set", label: "is set" },
  { value: "is_not_set", label: "is not set" },
];

const SPINTAX_RE = /\{[^{|}]*\|[^{|}]*\}/;

const stripHtml = (html) => {
  if (!html || !html.includes("<")) return html;
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const Icon = ({ n, s = 16, c = "currentColor" }) => {
  const icons = {
    close: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    ),
    plus: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
      </svg>
    ),
    trash: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
      </svg>
    ),
    chevron: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    ),
    chevronLeft: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    ),
    info: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
    ),
    check: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    lightning: (
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
  };
  return icons[n] || null;
};

function FieldSelect({ value, onChange, fields }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef();

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const filtered = fields.filter(f => f.text.toLowerCase().includes(search.toLowerCase()));
  const selected = fields.find(f => f.key === value);

  return (
    <div ref={ref} className="cb-select">
      <button
        onClick={() => setOpen(p => !p)}
        className={`cb-select-trigger ${open ? "open" : ""}`}
      >
        <span className="cb-trigger-text">
          {selected ? selected.text : "Select field"}
        </span>
        <span className={`cb-trigger-icon ${open ? "rotate" : ""}`}>
          <Icon n="chevron" s={13} c="#9CA3AF" />
        </span>
      </button>
      {open && (
        <div className="cb-select-dropdown">
          <div className="cb-search-wrap">
            <input
              autoFocus
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search fields…"
            />
          </div>
          <div className="cb-options-list">
            {filtered.map(f => (
              <button
                key={f.key}
                onClick={() => { onChange(f.key); setOpen(false); setSearch(""); }}
                className="cb-option-item"
              >
                {f.text}
                {value === f.key && <Icon n="check" s={13} c="#3953FB" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function OperatorSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const selected = OPERATORS.find(o => o.value === value);

  return (
    <div ref={ref} className="cb-select" style={{ width: 168, flexShrink: 0 }}>
      <button
        onClick={() => setOpen(p => !p)}
        className={`cb-select-trigger ${open ? "open" : ""}`}
      >
        <span>{selected?.label || "operator"}</span>
        <span className={`cb-trigger-icon ${open ? "rotate" : ""}`}>
          <Icon n="chevron" s={13} c="#9CA3AF" />
        </span>
      </button>
      {open && (
        <div className="cb-select-dropdown" style={{ width: "100%", overflow: "hidden" }}>
          <div className="cb-options-list">
            {OPERATORS.map(op => (
              <button
                key={op.value}
                onClick={() => { onChange(op.value); setOpen(false); }}
                className="cb-option-item"
              >
                {op.label}
                {value === op.value && <Icon n="check" s={13} c="#3953FB" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function ConditionBranch({ index, total, cond, onChange, onDelete, fields, handleTokenSelect }) {
  const [showTokenPopup, setShowTokenPopup] = useState(false);
  const cursorPos = useRef(0);
  const isIf = index === 0;
  const needsVal = !["is_set", "is_not_set"].includes(cond.operator);

  return (
    <div className="cb-branch">
      <div className="cb-branch-header">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div className="cb-drag-handle">
            {[0, 1, 2, 3, 4, 5].map(i => (
              <div key={i} className="cb-dot" />
            ))}
          </div>
          <span className={`cb-condition-label ${isIf ? "cb-if-label" : "cb-elif-label"}`}>
            {isIf ? "IF" : "ELSE IF"}
          </span>
          <span className="cb-condition-num">Condition {index + 1}</span>
        </div>
        {total > 1 && (
          <button onClick={onDelete} className="cb-delete-btn">
            <Icon n="trash" s={13} c="currentColor" />
          </button>
        )}
      </div>

      <div className="cb-branch-content">
        <div className="cb-selects-row">
          <FieldSelect value={cond.field} onChange={v => onChange({ ...cond, field: v })} fields={fields} />
          <OperatorSelect value={cond.operator} onChange={v => onChange({ ...cond, operator: v, value: "" })} />
          {needsVal && (
            <input
              value={cond.value}
              onChange={e => onChange({ ...cond, value: e.target.value })}
              placeholder="Enter value…"
              className="cb-value-input"
            />
          )}
        </div>
      </div>

      <div className="cb-then-send">
        <div className="cb-line" />
        <span>then send</span>
      </div>

      <div className="cb-textarea-wrapper">
        <textarea
          value={cond.content || ""}
          onChange={e => onChange({ ...cond, content: e.target.value })}
          onMouseUp={e => { cursorPos.current = e.target.selectionStart; }}
          onKeyUp={e => { cursorPos.current = e.target.selectionStart; }}
          placeholder="Define content when condition is matched"
          rows={4}
        />
        <div className="cb-insert-var">
          <span onClick={() => setShowTokenPopup(p => !p)}>
            {`{ X } Insert Variable`}
          </span>
          {showTokenPopup && (
            <TokenVariable
              tokenCbk={(val) => { handleTokenSelect(val); setShowTokenPopup(false); }}
              closeCbk={() => setShowTokenPopup(false)}
              pageType="sequences"
              showInboxTokens={false}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function PreviewLogic({ conditions, fallback }) {
  const labels = ["A", "B", "C", "D", "E"];
  const active = conditions.filter(c => c.field);

  if (!active.length && !fallback) {
    return (
      <div style={{ padding: "48px 24px", textAlign: "center" }}>
        <div style={{ opacity: 0.3, marginBottom: 10 }}><Icon n="info" s={28} c="#6b7280" /></div>
        <div style={{ fontSize: 14, fontWeight: 500, color: "#6b7280", marginBottom: 4 }}>No conditions configured</div>
        <div style={{ fontSize: 13, color: "#9ca3af" }}>Switch to Configure to build your conditions</div>
      </div>
    );
  }

  return (
    <div className="cb-preview-container">
      <div className="cb-preview-title">Logic Flow</div>
      <div className="cb-logic-flow">
        {active.map((c, i) => {
          const op = OPERATORS.find(o => o.value === c.operator);
          return (
            <div key={i} className="cb-flow-item">
              <div className={`cb-flow-row ${i === 0 ? "cb-if" : "cb-elif"}`}>
                <div className={`cb-flow-type ${i === 0 ? "cb-if-bg" : "cb-elif-bg"}`}>
                  <span>{i === 0 ? "IF" : "ELSE IF"}</span>
                </div>
                <div className="cb-flow-content">
                  <span className="cb-field-name">{c.field}</span>
                  <span className="cb-operator-name">{op?.label}</span>
                  {c.value && <span className="cb-value-tag">"{c.value}"</span>}
                </div>
                <div className="cb-flow-arrow">
                  <span>→</span>
                  <span className="cb-var-badge">Var. {labels[i]}</span>
                </div>
              </div>
              {(i < active.length - 1 || fallback) && <div className="cb-flow-connector" />}
            </div>
          );
        })}
        {fallback && (
          <div className="cb-flow-item">
            <div className="cb-flow-row">
              <div className="cb-flow-type cb-else-bg">
                <span>ELSE</span>
              </div>
              <div className="cb-flow-content">No conditions matched</div>
              <div className="cb-flow-arrow">
                <span>→</span>
                <span className="cb-var-badge cb-fallback-badge">Fallback</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="cb-preview-info">
        <Icon n="info" s={13} c="#9ca3af" />
        Conditions are checked top-to-bottom. The first match wins — only one variation is sent per email.
      </div>
    </div>
  );
}

export default function ConditionBuilderPopup({ isOpen, onClose, onSave, initialConditions = [], initialFallback = "" }) {
  const [conditions, setConditions] = useState([]);
  const [fallback, setFallback] = useState("");
  const [tab, setTab] = useState("configure");
  const [showFallbackTokenPopup, setShowFallbackTokenPopup] = useState(false);
  const fallbackCursorPos = useRef(0);
  const cursorPos = useRef(0);

  const customFields = settingsStoreData.customFields || {};
  const allFields = TOKENS.map(t => {
    if (t.key && t.key.includes("customField")) {
      return { key: t.key, text: customFields[t.key] || t.text || t.key, value: t.value };
    }
    return { key: t.key, text: t.text || t.key, value: t.value };
  });

  useEffect(() => {
    if (isOpen) {
      if (initialConditions && initialConditions.length > 0) {
        const conds = initialConditions.filter(c => !c.default);
        const fallbackCond = initialConditions.find(c => c.default);
        setConditions(
          conds.length > 0
            ? conds.map((c, i) => ({ 
                ...c, 
                id: c.id || Math.random().toString(36).substr(2, 9), 
                content: stripHtml(c.content || "") 
              }))
            : [mkCond()]
        );
        const fb = stripHtml(fallbackCond?.content || "") || stripHtml(initialFallback || "");
        setFallback(fb);
      } else {
        setConditions([mkCond()]);
        setFallback("");
      }
      setTab("configure");
    }
  }, [isOpen, initialConditions, initialFallback]);

  const mkCond = () => ({
    id: Math.random().toString(36).substr(2, 9),
    field: "",
    operator: "equals",
    value: "",
    content: "",
  });

  const handleSave = () => {
    const allContents = [...conditions.map(c => c.content || ""), fallback || ""];
    for (const c of allContents) {
      if (SPINTAX_RE.test(c)) {
        alert("Personalization variables cannot contain spintax.");
        return;
      }
    }
    onSave({ branches: conditions, fallback });
    onClose();
  };

  const canSave = conditions.every(c => c.field && (c.operator === "is_set" || c.value) && c.content) && fallback;

  return (
    <div className={`cb-popup ${isOpen ? "is-open" : ""}`}>
      <div className="cb-header">
        <button onClick={onClose} className="cb-back-btn">
          <Icon n="chevronLeft" s={14} c="#3953FB" />
          Back to email
        </button>

        <div className="cb-tabs">
          {[["configure", "Configure"], ["preview", "Preview Logic"]].map(([t, l]) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`cb-tab-btn ${tab === t ? "active" : ""}`}
            >
              {l}
            </button>
          ))}
        </div>
      </div>

      <div className="cb-body">
        {tab === "configure" ? (
          <div style={{ maxWidth: 580, margin: "0 auto", padding: "24px" }}>
            <div style={{ marginBottom: 16 }}>
              <div className="cb-add-cond-badge">
                <Icon n="lightning" s={13} c="white" />
                <span>Add Condition</span>
              </div>
              <p style={{ margin: 0, fontSize: 13, color: "#6B7280", lineHeight: 1.6 }}>
                Show different words or phrases based on conditions for better personalization.
                You can add up to 10 conditions and a fallback content if none of the conditions is satisfied.
              </p>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {conditions.map((cond, i) => (
                <ConditionBranch
                  key={cond.id}
                  index={i}
                  total={conditions.length}
                  cond={cond}
                  onChange={u => setConditions(p => p.map((x, j) => j === i ? u : x))}
                  onDelete={() => setConditions(p => p.filter((_, idx) => idx !== i))}
                  fields={allFields}
                  handleTokenSelect={(val) => {
                    const pos = cursorPos.current;
                    setConditions(p => {
                      const n = [...p];
                      const current = n[i].content || "";
                      n[i].content = current.slice(0, pos) + val + current.slice(pos);
                      return n;
                    });
                    cursorPos.current = pos + val.length;
                  }}
                />
              ))}

              {conditions.length < 10 && (
                <button
                  onClick={() => setConditions(p => [...p, mkCond()])}
                  className="cb-add-another-btn"
                >
                  <Icon n="plus" s={14} c="currentColor" />
                  Add another condition
                  <span>({conditions.length}/10)</span>
                </button>
              )}

              <div className="cb-fallback-section">
                <div className="cb-fallback-divider">
                  <div className="cb-line" />
                  <span>Otherwise (Fallback)</span>
                  <div className="cb-line" />
                </div>

                <div className="cb-fallback-header">
                  <span className="cb-else-badge">ELSE</span>
                  <span>Sent when no conditions match</span>
                </div>

                <div className="cb-branch" style={{ borderTop: "none", borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                  <div className="cb-branch-content">
                    <div className="cb-textarea-wrapper">
                      <textarea
                        value={fallback}
                        onChange={e => setFallback(e.target.value)}
                        onMouseUp={e => { fallbackCursorPos.current = e.target.selectionStart; }}
                        onKeyUp={e => { fallbackCursorPos.current = e.target.selectionStart; }}
                        placeholder="Write fallback content shown when none of the conditions match…"
                        rows={4}
                      />
                    </div>
                    <div className="cb-insert-var">
                      <span onClick={() => setShowFallbackTokenPopup(p => !p)}>
                        {`{ X } Insert Variable`}
                      </span>
                      {showFallbackTokenPopup && (
                        <TokenVariable
                          tokenCbk={(value = "") => {
                            const pos = fallbackCursorPos.current;
                            setFallback(prev => prev.slice(0, pos) + value + prev.slice(pos));
                            fallbackCursorPos.current = pos + value.length;
                            setShowFallbackTokenPopup(false);
                          }}
                          closeCbk={() => setShowFallbackTokenPopup(false)}
                          pageType="sequences"
                          showInboxTokens={false}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <PreviewLogic conditions={conditions} fallback={fallback} />
        )}
      </div>

      <div className="cb-footer">
        <div className="cb-footer-info">
          <Icon n="info" s={13} c="#9ca3af" />
          Conditions checked top-to-bottom — first match wins
        </div>
        <div className="cb-actions">
          <button onClick={onClose} className="cb-btn-outline">
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={!canSave}
            className="cb-btn"
          >
            Save Condition
          </button>
        </div>
      </div>
    </div>
  );
}
